import { Link } from '@remix-run/react'

export default function PrivacyPolicy() {
	return (
		<main className="container flex flex-col justify-center pb-24 pt-5 text-sm">
			<div className="text-center">
				<h1 className="text-h1">Privacy</h1>
			</div>
			<div>
				<div className="ex-basic-2 text-sm">
					<div className="container">
						<div className="row">
							<div className="col-lg-10 offset-lg-1">
								<div className="text-container">
									<p>Last updated: March 22, 2020</p>
									<p>
										We use Your Personal data to provide and improve the Service. By using the Service, You agree to the
										collection and use of information in accordance with this Privacy Policy.
									</p>

									<p>
										This Privacy Policy may be updated periodically to reflect changes to our personal information
										practices. We strongly encourage you to refer to this Privacy Policy often for the latest
										information about our personal information practices.
									</p>
									<p>
										References to &#x201C;refundr&#x201D;, &#x201C;us&#x201D;, &#x201C;we&#x201D; or similar terms means
										REFUNDR Inc.
									</p>
								</div>

								<div className="text-container">
									<p className="text-lg font-bold">Types of personal information we collect</p>
									<p>
										refundr needs to collect personal information from our users, either directly or through persons or
										entities acting on our behalf, in order to provide services to you. This information includes:
									</p>
									<ul className="list-disc pt-5">
										<li>
											personal information that you enter on an income tax form, including your name, address, and other
											identifying and contact information, in addition to your tax and financial information, and your
											e-mail address;
										</li>
										<li>
											personal information that you enter or otherwise provide when you register or open an account,
											sign in, use a service, contact us for support, or give us feedback;
										</li>
										<li>diagnostic and usage data to improve refundr and ensure everything is working properly.</li>
									</ul>
									<p>
										refundr limits the collection of your personal information to the extent necessary to fulfill the
										purposes identified at the time of collection.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">How we use your personal information</p>
									<p>
										The personal information we collect when you open an account is used for the following purposes:
									</p>
									<ul className="list-disc pt-5">
										<li className="media">
											<div>to allow you to effectively partner with your tax consultant and file your tax return;</div>
										</li>
										<li className="media">
											<div>to allow you to effectively partner with your tax agency;</div>
										</li>
										<li className="media">
											<div>to manage our operations;</div>
										</li>
										<li className="media">
											<div>to improve our product offering; and</div>
										</li>
										<li className="media">
											<div>to comply with legal and regulatory requirements.</div>
										</li>
										<li className="media">
											<div>
												To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of
												electronic communication, such as a mobile application's push notifications regarding updates or
												informative communications related to the functionalities, products or contracted services,
												including the security updates, when necessary or reasonable for their implementation.
											</div>
										</li>
									</ul>
								</div>

								<div className="text-container">
									<p className="text-lg font-bold">When we access users&#x2019; personal information</p>
									<p>
										Notwithstanding any clause contained in this Privacy Policy, our users have the ability to choose
										which information we can access when they are not logged on to the Website, through their account
										settings.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">We implement safeguards to protect personal information</p>

									<p>
										Please visit our security page at <Link to="/security">refundr.ca/security</Link> to learn more
										about how we protect your personal information.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">We take privacy seriously</p>
									<p>
										We are responsible for ensuring that we adhere to this Privacy Policy. We invite any user or
										prospective user to contact us at <Link to="mailto:info@refundr.ca">info@refundr.ca</Link> with any
										questions regarding this Privacy Policy.
									</p>
								</div>

								<div className="text-container">
									<p className="text-lg font-bold">We restrict disclosure of personal information</p>

									<p>
										We will not disclose, trade, rent, sell or otherwise transfer your personal information, without
										your consent, except as otherwise set out in this Privacy Policy or as permitted or required by law.
									</p>

									<ul className="list-disc pt-5">
										<li className="media">
											<div>
												<strong>Service Providers:</strong> We may transfer your personal information to our affiliates
												and other third party service providers who provide various services on our behalf such as
												identity verification, technology, administration, printing, marketing and advertising, hosting,
												data analysis, research, legal and accounting.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Business Transactions:</strong> We may transfer any information we have about you as an
												asset in connection with a prospective or completed merger or sale (including transfers made as
												part of insolvency or bankruptcy proceedings) involving all or part of refundr or as part of a
												corporate reorganization or stock sale or other change in corporate control, including for the
												purpose of determining whether to proceed or continue with such transaction or business
												relationship.
											</div>
										</li>
									</ul>
								</div>

								<div className="text-container">
									<p className="text-lg font-bold">We will provide you with access to your information</p>

									<p>
										Individuals have the right to access, update, and correct inaccuracies in his/her personal
										information in refundr&#x2019;s custody and control, subject to certain exceptions prescribed by
										law. You may update certain profile information through your account settings. Otherwise, an
										individual wishing to request access, updating and corrections of inaccuracies in other of his or
										her personal information in our possession or control may send a written request to this effect to
										refundr at the contact information below. We may request certain personal information for the
										purposes of verifying the identity of the individual seeking access to their personal information
										records.
									</p>

									<p>
										<Link to="mailto:info@refundr.ca">info@refundr.ca</Link>
									</p>
								</div>

								<div className="text-container">
									<p className="text-lg font-bold">Collecting and Using Your Personal Data</p>
									<p className="text-lg font-bold">Types of Data Collected</p>
								</div>

								<div className="text-container">
									<p className="text-lg font-bold">Usage Data</p>
									<p>Usage Data is collected automatically when using the Service.</p>
									<p>
										Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP
										address), browser type, browser version, the pages of our Service that You visit, the time and date
										of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
									</p>
									<p>
										When You access the Service by or through a mobile device, We may collect certain information
										automatically, including, but not limited to, the type of mobile device You use, Your mobile device
										unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile
										Internet browser You use, unique device identifiers and other diagnostic data.
									</p>
									<p>
										We may also collect information that Your browser sends whenever You visit our Service or when You
										access the Service by or through a mobile device.
									</p>
								</div>

								<div className="text-container">
									<p className="text-lg font-bold">Other Information Collected while Using the Application</p>
									<p>
										While using Our Application, in order to provide features of Our Application, We may collect, with
										your prior permission:
									</p>
									<ul className="list-disc pt-5">
										<li className="media">
											<div>Pictures and other information from your Device's camera and photo library</div>
										</li>
									</ul>
									<p>
										We use this information to provide features of Our Service, to improve and customize Our Service.
										The information may be uploaded to the Company's servers and/or a Service Provider's server or it be
										simply stored on Your device.
									</p>
									<p>
										You can enable or disable access to this information at any time, through Your Device settings. You
										can also enable or disable location services when You use Our Service at any time, through Your
										Device settings.
									</p>
								</div>

								<div className="text-container">
									<p className="text-lg font-bold">Retention of Your Personal Data</p>
									<p>
										The Company will retain Your Personal Data only for as long as is necessary for the purposes set out
										in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply
										with our legal obligations (for example, if we are required to retain your data to comply with
										applicable laws), resolve disputes, and enforce our legal agreements and policies.
									</p>
									<p>
										The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally
										retained for a shorter period of time, except when this data is used to strengthen the security or
										to improve the functionality of Our Service, or We are legally obligated to retain this data for
										longer time periods.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Transfer of Your Personal Data</p>
									<p>
										Your information, including Personal Data, is processed at the Company's operating offices and in
										any other places where the parties involved in the processing are located. It means that this
										information may be transferred to — and maintained on — computers located outside of Your state,
										province, country or other governmental jurisdiction where the data protection laws may differ than
										those from Your jurisdiction.
									</p>
									<p>
										Your consent to this Privacy Policy followed by Your submission of such information represents Your
										agreement to that transfer.
									</p>
									<p>
										The Company will take all steps reasonably necessary to ensure that Your data is treated securely
										and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to
										an organization or a country unless there are adequate controls in place including the security of
										Your data and other personal information.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Disclosure of Your Personal Data</p>

									<h5>Law enforcement</h5>
									<p>
										Under certain circumstances, the Company may be required to disclose Your Personal Data if required
										to do so by law or in response to valid requests by public authorities (e.g. a court or a government
										agency).
									</p>
									<h5>Other legal requirements</h5>
									<p>
										The Company may disclose Your Personal Data in the good faith belief that such action is necessary
										to:
									</p>
									<ul className="list-disc pt-5">
										<li className="media">
											<div>Comply with a legal obligation</div>
										</li>
										<li className="media">
											<div>Protect and defend the rights or property of the Company</div>
										</li>
										<li className="media">
											<div>Prevent or investigate possible wrongdoing in connection with the Service</div>
										</li>
										<li className="media">
											<div>Protect the personal safety of Users of the Service or the public</div>
										</li>
										<li className="media">
											<div>Protect against legal liability</div>
										</li>
									</ul>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Security of Your Personal Data</p>
									<p>
										The security of Your Personal Data is important to Us, but remember that no method of transmission
										over the Internet, or method of electronic storage is 100% secure. While We strive to use
										commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute
										security.
									</p>
								</div>

								<div className="text-container">
									<p className="text-lg font-bold">Email Marketing</p>
									<p>
										We may use Your Personal Data to contact You with newsletters, marketing or promotional materials
										and other information that may be of interest to You. You may opt-out of receiving any, or all, of
										these communications from Us by following the unsubscribe link or instructions provided in any email
										We send or by contacting Us.
									</p>
									<p>We may use Email Marketing Service Providers to manage and send emails to You.</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Payments</p>
									<p>
										We may provide paid products and/or services within the Service. In that case, we may use
										third-party services for payment processing (e.g. payment processors).
									</p>
									<p>
										We will not store or collect Your payment card details. That information is provided directly to Our
										third-party payment processors whose use of Your personal information is governed by their Privacy
										Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI
										Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American
										Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.
									</p>
									<ul className="list-disc pt-5">
										<li className="media">
											<div>
												<p>
													<strong>Stripe</strong>
												</p>
												<p>
													Their Privacy Policy can be viewed at{' '}
													<a href="https://stripe.com/us/privacy">https://stripe.com/us/privacy</a>
												</p>
											</div>
										</li>
									</ul>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">GDPR Privacy</p>
									<h5>Legal Basis for Processing Personal Data under GDPR</h5>
									<p>We may process Personal Data under the following conditions:</p>

									<ul className="list-disc pt-5">
										<li className="media">
											<div>
												<strong>Consent:</strong> You have given Your consent for processing Personal Data for one or
												more specific purposes.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Performance of a contract:</strong> Provision of Personal Data is necessary for the
												performance of an agreement with You and/or for any pre-contractual obligations thereof.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Legal obligations:</strong> Processing Personal Data is necessary for compliance with a
												legal obligation to which the Company is subject.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Vital interests:</strong> Processing Personal Data is necessary in order to protect Your
												vital interests or of another natural person.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Public interests:</strong> Processing Personal Data is related to a task that is carried
												out in the public interest or in the exercise of official authority vested in the Company.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Legitimate interests:</strong> Processing Personal Data is necessary for the purposes of
												the legitimate interests pursued by the Company.
											</div>
										</li>
									</ul>
									<p>
										In any case, the Company will gladly help to clarify the specific legal basis that applies to the
										processing, and in particular whether the provision of Personal Data is a statutory or contractual
										requirement, or a requirement necessary to enter into a contract.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Your Rights under the GDPR</p>
									<p>
										The Company undertakes to respect the confidentiality of Your Personal Data and to guarantee You can
										exercise Your rights.
									</p>
									<p>You have the right under this Privacy Policy, and by law if You are within the EU, to:</p>

									<ul className="list-disc pt-5">
										<li className="media">
											<div>
												<strong>Request access to Your Personal Data.</strong> The right to access, update or delete the
												information We have on You. Whenever made possible, you can access, update or request deletion
												of Your Personal Data directly within Your account settings section. If you are unable to
												perform these actions yourself, please contact Us to assist You. This also enables You to
												receive a copy of the Personal Data We hold about You.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Request correction of the Personal Data that We hold about You.</strong> You have the
												right to to have any incomplete or inaccurate information We hold about You corrected.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Object to processing of Your Personal Data.</strong>
												This right exists where We are relying on a legitimate interest as the legal basis for Our
												processing and there is something about Your particular situation, which makes You want to
												object to our processing of Your Personal Data on this ground. You also have the right to object
												where We are processing Your Personal Data for direct marketing purposes.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Request erasure of Your Personal Data.</strong> You have the right to ask Us to delete
												or remove Personal Data when there is no good reason for Us to continue processing it.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Request the transfer of Your Personal Data.</strong> We will provide to You, or to a
												third-party You have chosen, Your Personal Data in a structured, commonly used, machine-readable
												format. Please note that this right only applies to automated information which You initially
												provided consent for Us to use or where We used the information to perform a contract with You.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Withdraw Your consent.</strong> You have the right to withdraw Your consent on using
												your Personal Data. If You withdraw Your consent, We may not be able to provide You with access
												to certain specific functionalities of the Service.
											</div>
										</li>
									</ul>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Exercising of Your GDPR Data Protection Rights</p>
									<p>
										You may exercise Your rights of access, rectification, cancellation and opposition by contacting Us.
										Please note that we may ask You to verify Your identity before responding to such requests. If You
										make a request, We will try our best to respond to You as soon as possible.
									</p>
									<p>
										You have the right to complain to a Data Protection Authority about Our collection and use of Your
										Personal Data. For more information, if You are in the European Economic Area (EEA), please contact
										Your local data protection authority in the EEA.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">CCPA Privacy</p>
									<h5>Your Rights under the CCPA</h5>
									<p>
										Under this Privacy Policy, and by law if You are a resident of California, You have the following
										rights:
									</p>
									<ul className="list-disc pt-5">
										<li className="media">
											<div>
												<strong>The right to notice.</strong> You must be properly notified which categories of Personal
												Data are being collected and the purposes for which the Personal Data is being used.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>The right to access / the right to request.</strong> The CCPA permits You to request and
												obtain from the Company information regarding the disclosure of Your Personal Data that has been
												collected in the past 12 months by the Company or its subsidiaries to a third-party for the
												third party's direct marketing purposes.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>The right to say no to the sale of Personal Data.</strong> You also have the right to
												ask the Company not to sell Your Personal Data to third parties. You can submit such a request
												by visiting our "Do Not Sell My Personal Information" section or web page.
											</div>
										</li>
										<li className="media">
											<div>
												<p>
													<strong>The right to know about Your Personal Data.</strong> You have the right to request and
													obtain from the Company information regarding the disclosure of the following:
												</p>
												<ul className="list-disc pt-5">
													<li className="media">
														<div>The categories of Personal Data collected</div>
													</li>
													<li className="media">
														<div>The sources from which the Personal Data was collected</div>
													</li>
													<li className="media">
														<div>The business or commercial purpose for collecting or selling the Personal Data</div>
													</li>
													<li className="media">
														<div>Categories of third parties with whom We share Personal Data</div>
													</li>
													<li className="media">
														<div>The specific pieces of Personal Data we collected about You</div>
													</li>
												</ul>
											</div>
										</li>
										<li className="media">
											<div>
												<strong>The right to delete Personal Data.</strong> You also have the right to request the
												deletion of Your Personal Data that have been collected in the past 12 months.
											</div>
										</li>
										<li className="media">
											<div>
												<p>
													<strong>The right not to be discriminated against.</strong> You have the right not to be
													discriminated against for exercising any of Your Consumer's rights, including by:
												</p>
												<ul className="list-disc pt-5">
													<li className="media">
														<div>Denying goods or services to You</div>
													</li>
													<li className="media">
														<div>
															Charging different prices or rates for goods or services, including the use of discounts
															or other benefits or imposing penalties
														</div>
													</li>
													<li className="media">
														<div>Providing a different level or quality of goods or services to You</div>
													</li>
													<li className="media">
														<div>
															Suggesting that You will receive a different price or rate for goods or services or a
															different level or quality of goods or services.
														</div>
													</li>
												</ul>
											</div>
										</li>
									</ul>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Exercising Your CCPA Data Protection Rights</p>
									<p>
										In order to exercise any of Your rights under the CCPA, and if you are a California resident, You
										can email or call us or visit our "Do Not Sell My Personal Information" section or web page.
									</p>
									<p>
										The Company will disclose and deliver the required information free of charge within 45 days of
										receiving Your verifiable request. The time period to provide the required information may be
										extended once by an additional 45 days when reasonable necessary and with prior notice.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Do Not Sell My Personal Information</p>
									<p>
										We do not sell personal information. However, the Service Providers we partner with (for example,
										our advertising partners) may use technology on the Service that "sells" personal information as
										defined by the CCPA law.
									</p>
									<p>
										If you wish to opt out of the use of your personal information for interest-based advertising
										purposes and these potential sales as defined under CCPA law, you may do so by following the
										instructions below.
									</p>
									<p>
										Please note that any opt out is specific to the browser You use. You may need to opt out on every
										browser that you use.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Website</p>
									<p>
										You can opt out of receiving ads that are personalized as served by our Service Providers by
										following our instructions presented on the Service:
									</p>
									<ul className="list-disc pt-5">
										<li className="media">
											<div>From Our "Cookie Consent" notice banner</div>
										</li>
										<li className="media">
											<div>Or from Our "CCPA Opt-out" notice banner</div>
										</li>
										<li className="media">
											<div>Or from Our "Do Not Sell My Personal Information" notice banner</div>
										</li>
										<li className="media">
											<div>Or from Our "Do Not Sell My Personal Information" link</div>
										</li>
									</ul>
									<p>
										The opt out will place a cookie on Your computer that is unique to the browser You use to opt out.
										If you change browsers or delete the cookies saved by your browser, you will need to opt out again.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Mobile Devices</p>
									<p>
										Your mobile device may give you the ability to opt out of the use of information about the apps you
										use in order to serve you ads that are targeted to your interests:
									</p>
									<ul className="list-disc pt-5">
										<li className="media">
											<div>"Opt out of Interest-Based Ads" or "Opt out of Ads Personalization" on Android devices</div>
										</li>
										<li className="media">
											<div>"Limit Ad Tracking" on iOS devices</div>
										</li>
									</ul>
									<p>
										You can also stop the collection of location information from Your mobile device by changing the
										preferences on your mobile device.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">
										"Do Not Track" Policy as Required by California Online Privacy Protection Act (CalOPPA)
									</p>
									<p>Our Service does not respond to Do Not Track signals.</p>
									<p>
										However, some third party websites do keep track of Your browsing activities. If You are visiting
										such websites, You can set Your preferences in Your web browser to inform websites that You do not
										want to be tracked. You can enable or disable DNT by visiting the preferences or settings page of
										Your web browser.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Children's Privacy</p>
									<p>
										Our Service does not address anyone under the age of 13. We do not knowingly collect personally
										identifiable information from anyone under the age of 13. If You are a parent or guardian and You
										are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware
										that We have collected Personal Data from anyone under the age of 13 without verification of
										parental consent, We take steps to remove that information from Our servers.
									</p>
									<p>
										We also may limit how We collect, use, and store some of the information of Users between 13 and 18
										years old. In some cases, this means We will be unable to provide certain functionality of the
										Service to these users.
									</p>
									<p>
										If We need to rely on consent as a legal basis for processing Your information and Your country
										requires consent from a parent, We may require Your parent's consent before We collect and use that
										information.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Links to Other Websites</p>
									<p>
										Our Service may contain links to other websites that are not operated by Us. If You click on a third
										party link, You will be directed to that third party's site. We strongly advise You to review the
										Privacy Policy of every site You visit.
									</p>
									<p>
										We have no control over and assume no responsibility for the content, privacy policies or practices
										of any third party sites or services.
									</p>
								</div>
								<div className="text-container">
									<p className="text-lg font-bold">Changes to this Privacy Policy</p>
									<p>
										We may update our Privacy Policy from time to time. We will notify You of any changes by posting the
										new Privacy Policy on this page.
									</p>
									<p>
										We will let You know via email and/or a prominent notice on Our Service, prior to the change
										becoming effective and update the "Last updated" date at the top of this Privacy Policy.
									</p>
									<p>
										You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy
										Policy are effective when they are posted on this page.
									</p>
								</div>

								<div className="text-container">
									<h3 className="text-h3">Interpretation and Definitions</h3>
									<p className="text-lg font-bold">Interpretation</p>
									<p>
										The words of which the initial letter is capitalized have meanings defined under the following
										conditions.
									</p>
									<p>
										The following definitions shall have the same meaning regardless of whether they appear in singular
										or in plural.
									</p>
								</div>

								<div className="text-container">
									<p className="text-lg font-bold">Definitions</p>
									<p>For the purposes of this Privacy Policy:</p>
									<ul className="list-disc pt-5">
										<li className="media">
											<div>
												<p>
													<strong>You</strong> means the individual accessing or using the Service, or the company, or
													other legal entity on behalf of which such individual is accessing or using the Service, as
													applicable.
												</p>
												<p>
													Under GDPR (General Data Protection Regulation), You can be referred to as the Data Subject or
													as the User as you are the individual using the Service.
												</p>
											</div>
										</li>
										<li className="media">
											<div>
												<p>
													<strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this
													Agreement) refers to REFUNDR INC, 8534 rue Helene, Lasalle, Quebec, H8N1Z4.
												</p>
												<p>For the purpose of the GDPR, the Company is the Data Controller.</p>
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Application</strong> means the software program provided by the Company downloaded by
												You on any electronic device, named refundr
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Affiliate</strong> means an entity that controls, is controlled by or is under common
												control with a party, where "control" means ownership of 50% or more of the shares, equity
												interest or other securities entitled to vote for election of directors or other managing
												authority.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Account</strong> means a unique account created for You to access our Service or parts
												of our Service.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Service</strong> refers to the Application.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Country</strong> refers to: Canada
											</div>
										</li>
										<li className="media">
											<div>
												<p>
													<strong>Service Provider</strong> means any natural or legal person who processes the data on
													behalf of the Company. It refers to third-party companies or individuals employed by the
													Company to facilitate the Service, to provide the Service on behalf of the Company, to perform
													services related to the Service or to assist the Company in analyzing how the Service is used.
												</p>
												<p>For the purpose of the GDPR, Service Providers are considered Data Processors.</p>
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Third-party Social Media Service</strong> refers to any website or any social network
												website through which a User can log in or create an account to use the Service.
											</div>
										</li>
										<li className="media">
											<div>
												<p>
													<strong>Personal Data</strong> is any information that relates to an identified or
													identifiable individual.
												</p>
												<p>
													For the purposes for GDPR, Personal Data means any information relating to You such as a name,
													an identification number, location data, online identifier or to one or more factors specific
													to the physical, physiological, genetic, mental, economic, cultural or social identity.
												</p>
												<p>
													For the purposes of the CCPA, Personal Data means any information that identifies, relates to,
													describes or is capable of being associated with, or could reasonably be linked, directly or
													indirectly, with You.
												</p>
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Device</strong> means any device that can access the Service such as a computer, a
												cellphone or a digital tablet.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Usage Data</strong> refers to data collected automatically, either generated by the use
												of the Service or from the Service infrastructure itself (for example, the duration of a page
												visit).
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Data Controller</strong>, for the purposes of the GDPR (General Data Protection
												Regulation), refers to the Company as the legal person which alone or jointly with others
												determines the purposes and means of the processing of Personal Data.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Do Not Track</strong> (DNT) is a concept that has been promoted by US regulatory
												authorities, in particular the U.S. Federal Trade Commission (FTC), for the Internet industry to
												develop and implement a mechanism for allowing internet users to control the tracking of their
												online activities across websites.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Business</strong>, for the purpose of the CCPA (California Consumer Privacy Act), refers
												to the Company as the legal entity that collects Consumers' personal information and determines
												the purposes and means of the processing of Consumers' personal information, or on behalf of
												which such information is collected and that alone, or jointly with others, determines the
												purposes and means of the processing of consumers' personal information, that does business in
												the State of California.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Consumer</strong>, for the purpose of the CCPA (California Consumer Privacy Act), means
												a natural person who is a California resident. A resident, as defined in the law, includes (1)
												every individual who is in the USA for other than a temporary or transitory purpose, and (2)
												every individual who is domiciled in the USA who is outside the USA for a temporary or
												transitory purpose.
											</div>
										</li>
										<li className="media">
											<div>
												<strong>Sale</strong>, for the purpose of the CCPA (California Consumer Privacy Act), means
												selling, renting, releasing, disclosing, disseminating, making available, transferring, or
												otherwise communicating orally, in writing, or by electronic or other means, a Consumer's
												Personal information to another business or a third party for monetary or other valuable
												consideration.
											</div>
										</li>
									</ul>
								</div>

								<div className="text-container">
									<p className="text-lg font-bold">Contact Us</p>
									<p>If you have any questions about this Privacy Policy, You can contact us:</p>
									<ul className="list-disc pt-5">
										<li className="media">
											<div>By visiting this page on our website: https://www.refundr.ca/</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	)
}
